export const CURATED_COLLECTIONS = [
  {
    slug: "luxury-central",
    eyebrow: "Curated Collection",
    title: "Luxury Central Collection",
    shortDescription: "Prime central addresses across the city core for buyers chasing prestige, convenience, and investment-grade positioning.",
    description:
      "A premium shortlist of high-conviction homes in Singapore’s most desirable central districts. This collection is designed for buyers who want elegant addresses, elite connectivity, and stronger long-term prestige value.",
    category: "buy",
    districts: ["D01", "D02", "D09", "D10", "D11"],
    heroStats: [
      { label: "Coverage", value: "CBD to Prime Core Central" },
      { label: "Best fit", value: "Luxury buyers & investors" },
      { label: "Why now", value: "Prestige, liquidity, resilience" },
    ],
  },
  {
    slug: "family-east-coast",
    eyebrow: "Curated Collection",
    title: "Family East Coast Collection",
    shortDescription: "Homes in lifestyle-led eastern districts where schools, amenities, and family liveability matter most.",
    description:
      "A softer, family-first shortlist across the east where lifestyle, usable layouts, and everyday convenience come together. Ideal for buyers prioritising schools, coastal living, and stable owner-occupier appeal.",
    category: "buy",
    districts: ["D14", "D15", "D16"],
    heroStats: [
      { label: "Coverage", value: "Katong to Upper East Coast" },
      { label: "Best fit", value: "Families & upgraders" },
      { label: "Why now", value: "Lifestyle, schools, long-term hold" },
    ],
  },
  {
    slug: "new-launch-watchlist",
    eyebrow: "Curated Collection",
    title: "New Launch Watchlist",
    shortDescription: "A clean launch-tracking page for active buyers monitoring the strongest developer opportunities across the island.",
    description:
      "A dynamic watchlist for buyers tracking launch momentum, floor-plan options, and district narratives across the latest developer releases. Built to help serious buyers compare launch opportunities with less noise.",
    category: "new_launch",
    districts: [],
    heroStats: [
      { label: "Coverage", value: "Islandwide launch pipeline" },
      { label: "Best fit", value: "Launch buyers & investors" },
      { label: "Why now", value: "Compare pricing, plans, and location" },
    ],
  },
];

export const getCuratedCollection = (slug) => CURATED_COLLECTIONS.find((collection) => collection.slug === slug);